import React from 'react';
import ButtonFilled from '../../components/button-filled';
import CircleExclamation from '../../assets/images/icons/circle-exclamation.svg'
import XMark from '../../assets/images/icons/xmark.svg'

const OrderItemDeleteModal = ({ isOpen, onConfirm, onCancel, bodyText }) => {
  return (
    <>
        {isOpen && (
            <div className='order-item-delete-modal'>
                <div className='card'>
                    <div className='header'>
                        <img src={CircleExclamation} loading='eager'/>
                        <p>Delete Product</p>
                        <img className='close-modal' src={XMark} onClick={onCancel} loading='eager'/>
                    </div>

                    <p className='main-text'>{bodyText}</p>

                    <div className='buttons-block'>
                        <ButtonFilled label='CANCEL' palette='secondary' size='regular' customStyles={{width: 187}} onClick={onCancel}/>
                        <ButtonFilled label='CONFIRM' palette='danger' size='regular' customStyles={{width: 187}} onClick={onConfirm}/>
                    </div>
                </div>
            </div>
        )}
    </>
  );
};

export default OrderItemDeleteModal;